import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'app-statistic-chart',
  templateUrl: './statistic-chart.component.html',
  styleUrls: ['./statistic-chart.component.scss']
})
export class StatisticChartComponent implements OnChanges {
  @Input() title: string;
  @Input() data: Array<any>;
  @Input() distance = 30;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data) {
      this.createChart(this.data);
      window.dispatchEvent(new Event('resize'));
    }
  }

  createChart(data: Array<any>): void {
    // @ts-ignore
    Highcharts.chart('statistic-chart', {
      chart: {
        type: 'pie',
      },
      title: false,
      tooltip: {
        enabled: false
      },
      accessibility: {
        point: {
          valueSuffix: '%'
        }
      },
      plotOptions: {
        pie: {
          allowPointSelect: false,
          cursor: 'default',
          dataLabels: {
            enabled: true,
            format: '{point.percentage:.0f}%',
            distance: this.distance,
            style: {
              color: '#2277ed'
            },
            filter: {
              property: 'percentage',
              operator: '>',
              value: 0
            }
          },
          showInLegend: true,
          states: false
        }
      },
      series: [{
        data
      }]
    });
  }
}
